import React from 'react';
import MarginGuardHeld from '../components/MarginGuardHeld';

// FIRST-RELEASE LEGACY UI PRESERVED, INACTIVE LINE COMMENTS ONLY
// Original source: 34b99b9f6e8d7980f6ee89d06ad8ba9515129386:frontend/src/pages/MarginGuardOrdersPage.js
// Original UTF-8 SHA256: 6b365a15e495bab18addd7233f29207da19d1e583aa73ff29fb40d7d1332ee31
// Held legacy UI cannot fetch, render historical scores, or execute a fallback.
// Restore only after verified tenant/staff access, current data, denial tests,
// independent review and explicit owner approval of restoration.
// BEGIN ORIGINAL SOURCE
// /**
//  * Margin Guard Orders Table Page
//  * 
//  * Detailed view of orders with risk filtering, deadlines, and trace links.
//  */
// 
// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate, useSearchParams } from 'react-router-dom';
// import {
//   Shield,
//   ChevronLeft,
//   Search,
//   Filter,
//   RefreshCw,
//   AlertTriangle,
//   Clock,
//   Package,
//   XCircle,
//   Calendar,
//   ExternalLink,
//   ChevronRight,
//   ChevronDown,
//   X,
//   Layers,
//   MapPin,
//   Truck,
//   Box
// } from 'lucide-react';
// import { toast } from 'sonner';
// 
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
// 
// // Risk type definitions with colors
// const RISK_TYPES = {
//   late_risk: { label: 'Late Risk', color: 'rose', icon: Clock },
//   expectation_gap: { label: 'Expectation Gap', color: 'amber', icon: Calendar },
//   backorder_risk: { label: 'Backorder Risk', color: 'orange', icon: Package },
//   pcr: { label: 'PCR', color: 'red', icon: XCircle },
//   unfulfilled_aging: { label: 'Unfulfilled Aging', color: 'purple', icon: AlertTriangle },
// };
// 
// // Filter Dropdown Component
// const FilterDropdown = ({ label, options, value, onChange, icon: Icon }) => {
//   const [isOpen, setIsOpen] = useState(false);
// 
//   return (
//     <div className="relative">
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
//           value ? 'bg-emerald-600 text-white' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'
//         }`}
//       >
//         {Icon && <Icon className="w-4 h-4" />}
//         {label}
//         {value && <span className="ml-1">: {value}</span>}
//         <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
//       </button>
//       
//       {isOpen && (
//         <>
//           <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
//           <div className="absolute top-full left-0 mt-1 w-48 bg-slate-900 border border-slate-700 rounded-lg shadow-lg z-20 py-1 max-h-60 overflow-y-auto">
//             <button
//               onClick={() => { onChange(null); setIsOpen(false); }}
//               className="w-full px-3 py-2 text-left text-sm text-slate-400 hover:bg-slate-800"
//             >
//               Clear filter
//             </button>
//             {options.map((option) => (
//               <button
//                 key={option.value}
//                 onClick={() => { onChange(option.value); setIsOpen(false); }}
//                 className={`w-full px-3 py-2 text-left text-sm hover:bg-slate-800 ${
//                   value === option.value ? 'text-emerald-400' : 'text-slate-200'
//                 }`}
//               >
//                 {option.label}
//               </button>
//             ))}
//           </div>
//         </>
//       )}
//     </div>
//   );
// };
// 
// // Order Status Badge
// const StatusBadge = ({ status }) => {
//   const statusColors = {
//     pending: 'bg-yellow-500/20 text-yellow-400',
//     processing: 'bg-blue-500/20 text-blue-400',
//     shipped: 'bg-purple-500/20 text-purple-400',
//     delivered: 'bg-emerald-500/20 text-emerald-400',
//     cancelled: 'bg-slate-500/20 text-slate-400',
//     fulfilled: 'bg-emerald-500/20 text-emerald-400',
//     unfulfilled: 'bg-amber-500/20 text-amber-400',
//     partial: 'bg-orange-500/20 text-orange-400',
//   };
// 
//   return (
//     <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${statusColors[status] || 'bg-slate-600/50 text-slate-300'}`}>
//       {status || 'unknown'}
//     </span>
//   );
// };
// 
// // Risk Badge
// const RiskBadge = ({ riskType, confidence }) => {
//   if (!riskType) return null;
// 
//   const risk = RISK_TYPES[riskType] || { label: riskType, color: 'slate', icon: AlertTriangle };
//   const Icon = risk.icon;
//   
//   const colorClasses = {
//     rose: 'bg-rose-500/20 text-rose-400 border-rose-500/30',
//     amber: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
//     orange: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
//     red: 'bg-red-500/20 text-red-400 border-red-500/30',
//     purple: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
//     slate: 'bg-slate-500/20 text-slate-400 border-slate-500/30',
//   };
// 
//   return (
//     <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border ${colorClasses[risk.color]}`}>
//       <Icon className="w-3 h-3" />
//       {risk.label}
//       {confidence && <span className="opacity-60">({Math.round(confidence * 100)}%)</span>}
//     </span>
//   );
// };
// 
// // Deadline Cell
// const DeadlineCell = ({ calendar, business }) => {
//   const now = new Date();
//   const calendarDate = calendar ? new Date(calendar) : null;
//   const businessDate = business ? new Date(business) : null;
//   
//   const formatDate = (date) => {
//     if (!date) return '—';
//     return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
//   };
//   
//   const isOverdue = (date) => date && date < now;
// 
//   return (
//     <div className="text-xs space-y-1">
//       <div className={`flex items-center gap-1 ${isOverdue(calendarDate) ? 'text-rose-400' : 'text-slate-300'}`}>
//         <Calendar className="w-3 h-3" />
//         <span>{formatDate(calendarDate)}</span>
//         {isOverdue(calendarDate) && <span className="text-rose-400">(overdue)</span>}
//       </div>
//       <div className={`flex items-center gap-1 ${isOverdue(businessDate) ? 'text-rose-400' : 'text-slate-400'}`}>
//         <Clock className="w-3 h-3" />
//         <span>{formatDate(businessDate)}</span>
//         {isOverdue(businessDate) && <span className="text-rose-400">(overdue)</span>}
//       </div>
//     </div>
//   );
// };
// 
// // Main Component
// export default function MarginGuardOrdersPage() {
//   const navigate = useNavigate();
//   const [searchParams, setSearchParams] = useSearchParams();
//   
//   const [loading, setLoading] = useState(true);
//   const [orders, setOrders] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(1);
//   const [pageSize] = useState(20);
//   
//   // Filters
//   const [riskType, setRiskType] = useState(searchParams.get('risk_type') || null);
//   const [node, setNode] = useState(searchParams.get('node') || null);
//   const [region, setRegion] = useState(searchParams.get('region') || null);
//   const [method, setMethod] = useState(searchParams.get('method') || null);
//   const [search, setSearch] = useState('');
//   
//   const [refreshing, setRefreshing] = useState(false);
// 
//   // Filter options (would come from API in real app)
//   const riskOptions = Object.entries(RISK_TYPES).map(([value, { label }]) => ({ value, label }));
//   const nodeOptions = [
//     { value: 'node-1', label: '3PL-A (West)' },
//     { value: 'node-2', label: '3PL-B (Northeast)' },
//     { value: 'node-3', label: 'In-House (Central)' },
//   ];
//   const regionOptions = [
//     { value: 'West', label: 'West Coast' },
//     { value: 'Northeast', label: 'Northeast' },
//     { value: 'South', label: 'South' },
//     { value: 'Midwest', label: 'Midwest' },
//   ];
//   const methodOptions = [
//     { value: 'Standard', label: 'Standard' },
//     { value: 'Expedited', label: 'Expedited' },
//     { value: 'Overnight', label: 'Overnight' },
//   ];
// 
//   // Fetch orders
//   const fetchOrders = useCallback(async () => {
//     try {
//       const params = new URLSearchParams();
//       params.append('page', page.toString());
//       params.append('page_size', pageSize.toString());
//       if (riskType) params.append('risk_type', riskType);
//       if (node) params.append('node', node);
//       if (region) params.append('region', region);
//       if (method) params.append('method', method);
//       
//       const res = await fetch(`${BACKEND_URL}/api/margin-guard/orders?${params}`);
//       if (res.ok) {
//         const data = await res.json();
//         setOrders(data.orders || []);
//         setTotal(data.total || 0);
//       }
//     } catch (error) {
//       console.error('Error fetching orders:', error);
//       toast.error('Failed to load orders');
//     } finally {
//       setLoading(false);
//     }
//   }, [page, pageSize, riskType, node, region, method]);
// 
//   // Update URL params when filters change
//   useEffect(() => {
//     const params = new URLSearchParams();
//     if (riskType) params.set('risk_type', riskType);
//     if (node) params.set('node', node);
//     if (region) params.set('region', region);
//     if (method) params.set('method', method);
//     setSearchParams(params);
//   }, [riskType, node, region, method, setSearchParams]);
// 
//   // Fetch on load and filter change
//   useEffect(() => {
//     setLoading(true);
//     fetchOrders();
//   }, [fetchOrders]);
// 
//   // Handle refresh
//   const handleRefresh = async () => {
//     setRefreshing(true);
//     await fetchOrders();
//     setRefreshing(false);
//     toast.success('Orders refreshed');
//   };
// 
//   // Clear all filters
//   const clearFilters = () => {
//     setRiskType(null);
//     setNode(null);
//     setRegion(null);
//     setMethod(null);
//     setPage(1);
//   };
// 
//   const hasFilters = riskType || node || region || method;
//   const totalPages = Math.ceil(total / pageSize);
// 
//   if (loading && orders.length === 0) {
//     return (
//       <div className="min-h-screen bg-slate-950 flex items-center justify-center">
//         <div className="text-center">
//           <RefreshCw className="w-8 h-8 text-emerald-500 animate-spin mx-auto mb-4" />
//           <p className="text-slate-400">Loading orders...</p>
//         </div>
//       </div>
//     );
//   }
// 
//   return (
//     <div className="min-h-screen bg-slate-950 px-6 py-8">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="flex items-center gap-4 mb-6">
//           <button
//             onClick={() => navigate('/dashboard/margin-guard')}
//             className="p-2 rounded-lg hover:bg-slate-800 text-slate-400 hover:text-white transition-colors"
//           >
//             <ChevronLeft className="w-5 h-5" />
//           </button>
//           <div className="flex-1">
//             <h1 className="text-2xl font-bold text-slate-100 flex items-center gap-2">
//               <Shield className="w-6 h-6 text-emerald-500" />
//               Orders
//             </h1>
//             <p className="text-sm text-slate-400">
//               {total.toLocaleString()} orders • Filter by risk type, node, region, or method
//             </p>
//           </div>
//           <button
//             onClick={handleRefresh}
//             disabled={refreshing}
//             className="px-4 py-2 bg-slate-800 hover:bg-slate-700 text-slate-100 rounded-lg font-medium transition-colors flex items-center gap-2 disabled:opacity-50"
//           >
//             <RefreshCw className={`w-4 h-4 ${refreshing ? 'animate-spin' : ''}`} />
//             Refresh
//           </button>
//         </div>
// 
//         {/* Filters */}
//         <div className="flex flex-wrap items-center gap-3 mb-6">
//           <div className="flex items-center gap-2 text-sm text-slate-400">
//             <Filter className="w-4 h-4" />
//             Filters:
//           </div>
//           
//           <FilterDropdown
//             label="Risk Type"
//             options={riskOptions}
//             value={riskType}
//             onChange={setRiskType}
//             icon={AlertTriangle}
//           />
//           
//           <FilterDropdown
//             label="Node"
//             options={nodeOptions}
//             value={node}
//             onChange={setNode}
//             icon={Layers}
//           />
//           
//           <FilterDropdown
//             label="Region"
//             options={regionOptions}
//             value={region}
//             onChange={setRegion}
//             icon={MapPin}
//           />
//           
//           <FilterDropdown
//             label="Method"
//             options={methodOptions}
//             value={method}
//             onChange={setMethod}
//             icon={Truck}
//           />
//           
//           {hasFilters && (
//             <button
//               onClick={clearFilters}
//               className="flex items-center gap-1 px-3 py-2 text-sm text-slate-400 hover:text-white transition-colors"
//             >
//               <X className="w-4 h-4" />
//               Clear all
//             </button>
//           )}
//           
//           <div className="flex-1" />
//           
//           {/* Search */}
//           <div className="relative">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
//             <input
//               type="text"
//               placeholder="Search orders..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               className="pl-9 pr-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-sm text-slate-100 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 w-64"
//             />
//           </div>
//         </div>
// 
//         {/* Table */}
//         <div className="rounded-2xl border border-slate-800 bg-slate-900/40 overflow-hidden">
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead>
//                 <tr className="border-b border-slate-800 bg-slate-900/60">
//                   <th className="text-left py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Order</th>
//                   <th className="text-left py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Node</th>
//                   <th className="text-left py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Region</th>
//                   <th className="text-left py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Method</th>
//                   <th className="text-left py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Deadlines</th>
//                   <th className="text-left py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Status</th>
//                   <th className="text-left py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Risk</th>
//                   <th className="text-right py-3 px-4 text-xs font-semibold text-slate-400 uppercase">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {orders.length === 0 ? (
//                   <tr>
//                     <td colSpan={8} className="py-12 text-center text-slate-400">
//                       {hasFilters ? (
//                         <div>
//                           <AlertTriangle className="w-8 h-8 mx-auto mb-2 text-slate-500" />
//                           <p>No orders match the current filters</p>
//                           <button
//                             onClick={clearFilters}
//                             className="mt-2 text-emerald-400 hover:text-emerald-300"
//                           >
//                             Clear filters
//                           </button>
//                         </div>
//                       ) : (
//                         <div>
//                           <Package className="w-8 h-8 mx-auto mb-2 text-slate-500" />
//                           <p>No orders found</p>
//                         </div>
//                       )}
//                     </td>
//                   </tr>
//                 ) : (
//                   orders.map((order) => (
//                     <tr key={order.order_id} className="border-b border-slate-800/50 hover:bg-slate-800/30">
//                       <td className="py-3 px-4">
//                         <div>
//                           <div className="text-sm font-medium text-slate-200">{order.order_number}</div>
//                           <div className="text-xs text-slate-500">
//                             {new Date(order.created_at).toLocaleDateString()}
//                           </div>
//                         </div>
//                       </td>
//                       <td className="py-3 px-4 text-sm text-slate-300">{order.node_name || '—'}</td>
//                       <td className="py-3 px-4 text-sm text-slate-300">{order.region || '—'}</td>
//                       <td className="py-3 px-4 text-sm text-slate-300">{order.shipping_method || '—'}</td>
//                       <td className="py-3 px-4">
//                         <DeadlineCell calendar={order.calendar_deadline} business={order.business_deadline} />
//                       </td>
//                       <td className="py-3 px-4">
//                         <StatusBadge status={order.status} />
//                       </td>
//                       <td className="py-3 px-4">
//                         <RiskBadge riskType={order.risk_type} confidence={order.confidence} />
//                       </td>
//                       <td className="py-3 px-4 text-right">
//                         {order.trace_id && (
//                           <button
//                             onClick={() => navigate(`/dashboard/margin-guard/traces/${order.trace_id}`)}
//                             className="inline-flex items-center gap-1 px-3 py-1.5 bg-slate-800 hover:bg-slate-700 text-slate-200 rounded-lg text-xs font-medium transition-colors"
//                           >
//                             View Trace
//                             <ExternalLink className="w-3 h-3" />
//                           </button>
//                         )}
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//           
//           {/* Pagination */}
//           {totalPages > 1 && (
//             <div className="flex items-center justify-between px-4 py-3 border-t border-slate-800">
//               <div className="text-sm text-slate-400">
//                 Showing {((page - 1) * pageSize) + 1} to {Math.min(page * pageSize, total)} of {total}
//               </div>
//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={() => setPage(Math.max(1, page - 1))}
//                   disabled={page === 1}
//                   className="p-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                 >
//                   <ChevronLeft className="w-4 h-4" />
//                 </button>
//                 <span className="text-sm text-slate-300">
//                   Page {page} of {totalPages}
//                 </span>
//                 <button
//                   onClick={() => setPage(Math.min(totalPages, page + 1))}
//                   disabled={page === totalPages}
//                   className="p-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                 >
//                   <ChevronRight className="w-4 h-4" />
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
// 
//         {/* Quick Stats */}
//         <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
//           <div className="rounded-xl border border-slate-800 bg-slate-900/40 p-4">
//             <div className="text-xs font-semibold text-slate-400 uppercase mb-1">Late Risk</div>
//             <div className="text-2xl font-bold text-rose-400">
//               {orders.filter(o => o.risk_type === 'late_risk').length}
//             </div>
//           </div>
//           <div className="rounded-xl border border-slate-800 bg-slate-900/40 p-4">
//             <div className="text-xs font-semibold text-slate-400 uppercase mb-1">Expectation Gap</div>
//             <div className="text-2xl font-bold text-amber-400">
//               {orders.filter(o => o.risk_type === 'expectation_gap').length}
//             </div>
//           </div>
//           <div className="rounded-xl border border-slate-800 bg-slate-900/40 p-4">
//             <div className="text-xs font-semibold text-slate-400 uppercase mb-1">Backorder Risk</div>
//             <div className="text-2xl font-bold text-orange-400">
//               {orders.filter(o => o.risk_type === 'backorder_risk').length}
//             </div>
//           </div>
//           <div className="rounded-xl border border-slate-800 bg-slate-900/40 p-4">
//             <div className="text-xs font-semibold text-slate-400 uppercase mb-1">No Risk</div>
//             <div className="text-2xl font-bold text-emerald-400">
//               {orders.filter(o => !o.risk_type).length}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// END ORIGINAL SOURCE

export default function HeldMarginGuardOrdersPage() { return <MarginGuardHeld/>; }
